import { render } from "./Berita.vue?vue&type=template&id=7c6ae4ca&scoped=true"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"

import "./Berita.vue?vue&type=style&index=0&id=7c6ae4ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6ae4ca"]])

export default __exports__